<crnt-form-control>
  @if (control.hasError()) {
    <rfa-errors slot="validation" [control]="control"></rfa-errors>
  }

  <crnt-form-control-label slot="label">
    <label
      [for]="control.id"
      [wlAutomationId]="control.options.dataAutomationId"
    >
      {{ control.options.label }}
      @if (showOptional) {
        <crnt-form-control-label-indicator>
          (optioneel)
        </crnt-form-control-label-indicator>
      }
    </label>
  </crnt-form-control-label>
  @if (control.options.helpText) {
    <crnt-form-control-help-text slot="help">
      {{ control.options.helpText }}
    </crnt-form-control-help-text>
  }

  <crnt-select>
    <select
      [id]="control.id"
      [formControl]="control"
      [wlTrackValueChange]="valueChangeTrackConfig()"
      [wlAutomationId]="control.options.dataAutomationId"
    >
      <option selected ngValue="">
        {{ control.options.emptyValueText ?? defaultEmptyValueText }}
      </option>
      @for (item of control.options.entries; track $index) {
        <option [ngValue]="item.value">{{ item.text }}</option>
      }
    </select>
  </crnt-select>
</crnt-form-control>
